import axios from "axios";
import { SECURITY, SECURITY_V2, CODE, GENERATE, FORGOT, REFRESH_TOKEN } from "endpointsConst";

const SecurityService = {};

SecurityService.generateCode = (data) => axios.post(SECURITY + CODE + GENERATE, data);

SecurityService.forgot = (data) => axios.post(SECURITY_V2 + FORGOT, data);

SecurityService.refreshToken = (data) => axios.post(SECURITY + REFRESH_TOKEN, data);

export { SecurityService };
